module.exports = __webpack_public_path__ + "static/img/200055.2b357dd4.png";